export default __webpack_public_path__ + "static/media/a3.4fdae740.png";